document.addEventListener('DOMContentLoaded', async function () {

    const selectElement = document.getElementById("comment-sort");

    if (selectElement) {
        selectElement.addEventListener("change", async function () {

            if (!devtricker_getTheLoggedUserId()) {
                this.value = "relevant";
                devtricker_openSocialLoginModal();
                return;
            }

            let selectedValue = this.value;

            if (selectedValue === "relevant") {
                await devtricker_orderCommentByRelevant();
            } else if (selectedValue === "recent") {
                await devtricker_orderCommentByDate();
            }
        });
    }
});

async function devtricker_orderCommentByRelevant() {

    let offcanvasCommentBody = document.querySelector('.offcanvas-body');
    let comments = document.querySelector('.comment-list');

    comments.innerHTML = '';

    g_devtricker_current_main_thread_comment_offset = 0;
    g_devtricker_current_child_comment_offset = {};
    g_devtricker_comment_order_by = 'relevance';
    g_devtricker_allow_comment_load_request = true;

    await loadCommentMainThread(offcanvasCommentBody);
}

async function devtricker_orderCommentByDate() {

    let offcanvasCommentBody = document.querySelector('.offcanvas-body');
    let comments = document.querySelector('.comment-list');

    comments.innerHTML = '';

    g_devtricker_current_main_thread_comment_offset = 0;
    g_devtricker_current_child_comment_offset = {};
    g_devtricker_comment_order_by = 'date';
    g_devtricker_allow_comment_load_request = true;

    await loadCommentMainThread(offcanvasCommentBody);
}
